import MonthRangeDatePicker from './components/date-picker';
import Icon from './components/icon';
import Input from './components/input';
import Select from './components/select';
import locale from './locale/index';

const components = {
    MonthRangeDatePicker,
    Icon,
    Input,
    Select
};

const iview = {
    ...components,
    iInput: Input,
    iSelect: Select,
};

const install = function(Vue, opts = {}) {
    if (install.installed) return;
    locale.use(opts.locale);
    locale.i18n(opts.i18n);

    Object.keys(iview).forEach(key => {
        Vue.component(key, iview[key]);
    });

    Vue.prototype.$IVIEW = {
        size: opts.size || ''
    };
};

// auto install
if (typeof window !== 'undefined' && window.Vue) {
    install(window.Vue);
}

const API = {
    version: process.env.VERSION, // eslint-disable-line no-undef
    locale: locale.use,
    i18n: locale.i18n,
    install,
    ...components
};

API.lang = (code) => {
    const langObject = window['iview/locale'].default;
    if (code === langObject.i.locale) locale.use(langObject);
    else console.log(`The ${code} language pack is not loaded.`); // eslint-disable-line no-console
};

module.exports.default = module.exports = API;   // eslint-disable-line no-undef



// WEBPACK FOOTER //
// ./src/index.js